import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { getAuth } from "firebase/auth";
import {getDatabase} from "firebase/database";
import { getFunctions } from "firebase/functions";
import { isTokenPath } from "./utils/tokenPaths";

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const db = getDatabase(app);
const functions = getFunctions(app, 'europe-north1');

// Analytics - only initialize in browser environment where supported, and
// never on a page whose URL carries an access token.
const analyticsPromise = typeof window !== 'undefined' && isTokenPath(window.location.pathname)
    ? Promise.resolve(null)
    : isSupported().then(supported => (supported ? getAnalytics(app) : null));

export { app, auth, db, functions, analyticsPromise };